export type Props = {
    'data-testid'?: string;
};

const NoResultsFound = ({'data-testid': dataTestId}: Props) => {
    return (
        <div
            data-testid={dataTestId}
            className='flex flex-col items-center justify-center py-8 gap-1'
        >
            <p className='text-base font-semibold text-gray-800 m-0'>No results found</p>
            <p className='text-sm text-gray-500 text-center m-0'>
                Try adjusting filter options to find what you&apos;re looking for.
            </p>
        </div>
    );
};

export default NoResultsFound;
